import md5 from 'js-md5';
import sha1 from 'sha1';
import { nextTick } from 'vue';

import { getTokenValidate, getTridToken } from '@/api/user';
import { delCookie, getCookie, setCookie } from '@/fe_modules/utils/cookie';
import router from '@/router';
import http from '@/utils/http';
import { currEvn } from '@/utils/http_help';

import * as bom from '../fe_modules/utils/bom';

//中间页回跳URl
const currentURL: string = window.location.href;
const url: URL = new URL(currentURL);
url.searchParams.delete('ticket');
const newURL: string = url.toString();

// LoginCallback中间页认证ticket回调地址
// const loginBackurl =
//   window.location.origin + '/web/logincallback?backurl=' + newURL;
// const loginTicketUrl =
//   window.location.origin + '/web/logincallback?backurl=' + currentURL;
// const serviceUrl = `http://passport.${currEvn}.iol8.net/login?service=${loginBackurl}`;

//路由钩子回跳URl
const loginBackurl = window.location.href;

let serviceUrl: string;
if (currEvn === 'dev') {
  serviceUrl = `http://passport.dev.iol8.net/cas/login?service=${loginBackurl}`;
} else if (currEvn === 'test') {
  serviceUrl = `http://passport.qa.iol8.net/cas/login?service=${loginBackurl}`;
} else if (currEvn === 'release') {
  serviceUrl = `http://passport.release.iol8.net/cas/login?service=${loginBackurl}`;
} else {
  serviceUrl = `https://passport.iol8.com/cas/login?service=${loginBackurl}`;
}

const currUrl = bom.getQuery('backurl') || window.location.origin;
const currentURL2: string = currUrl;
const url2: URL = new URL(currentURL2);
const urlParams = new URLSearchParams(url2.search);
let ticket: string;
if (bom.getQuery('ticket')) {
  ticket = bom.getQuery('ticket');
} else {
  ticket = urlParams.get('ticket') || '';
}
url2.searchParams.delete('ticket');
const currUrl2: string = url2.toString();

// console.log('ticket', ticket, currUrl2);
const trId =
  decodeURI(getCookie(`woordee_${currEvn}_talent_login_user`))
    .split('|')
    .reverse()[0] || '';

export const goLoginUrl = () => {
  if (window.location.host.includes('woordee')) return;
  // if (ticket) { //换路由验证
  // console.log('loginBackurl', loginTicketUrl);
  //   window.location.href = loginTicketUrl;
  // } else {
  //   window.location.href = serviceUrl;
  // }
  if (!ticket) {
    window.location.href = serviceUrl;
  }
};
export const isTokenValidate = () => {
  getTokenValidate();
};

export const goLogOut = () => {
  http({
    url: '/talent/ticket/loginOut',
    method: 'POST'
  });
  nextTick(() => {
    delCookie(`woordee_${currEvn}_talent_login_user`, '.iol8.com');
    delCookie(`woordee_${currEvn}_talent_login_token`, '.iol8.com');
    window.location.href = window.location.origin;
  });
};

//各种页面内的接口token过期，登录后跳中转页验证
const ticketToToken = () => {
  if (ticket) {
    getTridToken({
      ticket: ticket
    })
      .then((res) => {
        console.log('getToken', res, currUrl2);
        if (res.data.code == 0) {
          WtCookie(res.data.token, res.data.connectId);
          window.location.href = currUrl2;
        } else {
          console.log(res.data.message);
          window.location.href = currUrl2;
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  } else {
    if (!trId) {
      console.log('没有ticket,你还没登录');
      window.location.href = window.location.origin; //如果登录了没返回ticket就跳首页
    } else {
      window.location.href = currUrl2;
    }
  }
};

//页面内没过期，但是url含有ticket就刷新token
export const reUrlDelTicket = () => {
  if (ticket) {
    getTridToken({
      ticket: ticket
    }).then((res) => {
      if (res.data?.code == 0 || res.data?.code == 1) {
        if (res.data?.token && res.data?.connectId) {
          WtCookie(res.data.token, res.data.connectId);
        }
        const currentQuery = { ...router.currentRoute.value.query };
        delete currentQuery.ticket;
        // 使用新的查询参数进行路由重定向
        router.replace({ query: currentQuery });
      }
    });
  }
};

const WtCookie = (token: string, connectId: string) => {
  const sign = sha1(md5(connectId + md5(connectId) + 'E4&c3vE!vJxxqw1w'));
  const c_trid = `|${sign}|${connectId}`;

  const suffix = `.iol8.${currEvn === 'pro' ? 'com' : 'net'}`;

  setCookie(`woordee_${currEvn}_talent_login_user`, c_trid, suffix);
  setCookie(`woordee_${currEvn}_talent_login_token`, token, suffix);
};

export default ticketToToken;
